import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

const LoginPage = React.lazy(() => import('./modules/auth/pages/LoginPage'));
const DashboardPage = React.lazy(() => import('./modules/dashboard/pages/DashboardPage'));

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const user = localStorage.getItem('auth:user');
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App: React.FC = () => (
  <BrowserRouter>
    <Suspense fallback={<div>Carregando...</div>}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        {/* Novas rotas podem ser adicionadas abaixo */}
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default App;
